import { types } from './actions';

/* NOTE: Storing object because using more than just id in components */
const initialState = {
  ticketNumberObject: {},
};


const ticketNumberStatus = (state = initialState, action) => {
  switch (action.type) {
    case types.SELECT_TICKET_NUMBER: {
      const { ticketNumberObject } = action;
      return {
        ...state,
        ticketNumberObject,
      };
    }
    default:
      return state;
  }
};


export default ticketNumberStatus;
